import { render, staticRenderFns } from "./SlideCaptcha.vue?vue&type=template&id=45a3afa4&scoped=true"
import script from "./SlideCaptcha.vue?vue&type=script&lang=js"
export * from "./SlideCaptcha.vue?vue&type=script&lang=js"
import style0 from "./SlideCaptcha.vue?vue&type=style&index=0&id=45a3afa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a3afa4",
  null
  
)

export default component.exports